import {CalculatedRainWater, Marker} from "../App";

const reqHost = window.location.host == 'localhost:3000' ? 'http://localhost:8000/' : '/';

type ReportLinkResponse = {
    hash: string,
    link: string,
}
const generateReportLink = async (calculatedRainWater: CalculatedRainWater, marker: Marker): Promise<ReportLinkResponse> => {
    const body = {
        calculatedRainWater,
        marker
    }

    return await fetch(
        reqHost + "wp-json/rainwatercalculator/report/link",
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    ).then((response) => response.json());
}

export default generateReportLink